import React from 'react';
import { Bot } from 'lucide-react';
import { AudioEffect, AudioEffectControlProps } from './AudioEffect';
import { AudioSourceRegistry } from '../../../../dataTypes/liveStreamManagment/audioPipeline/AudioSourceRegistry';
import { LevelSlider } from '../LevelSlider';

export interface RobotConfig {
  /** Fréquence du porteur, en Hz — grave (20-40) pour le robot classique. */
  freqHz: number;
  /** Proportion de signal modulé mélangé au signal sec, 0-100%. */
  mix: number;
}

class RobotEffectImpl extends AudioEffect<RobotConfig> {
  readonly id = 'robot';
  readonly label = 'Robot';
  readonly icon = Bot;
  readonly description = 'Voix robotique — modulation en anneau par un oscillateur grave';
  readonly defaultConfig: RobotConfig = { freqHz: 35, mix: 100 };

  apply(registry: AudioSourceRegistry, regId: string, enabled: boolean, config: RobotConfig): void {
    registry.setRobotVoice(regId, enabled, config.freqHz, config.mix / 100);
  }

  renderControls({ config, onChange }: AudioEffectControlProps<RobotConfig>) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <LevelSlider
          label="Fréquence" value={config.freqHz}
          min={10} max={200} defaultValue={35} roundTo={1}
          format={v => `${v} Hz`}
          onChange={freqHz => onChange({ ...config, freqHz })}
        />
        <LevelSlider
          label="Mix" value={config.mix}
          min={0} max={100} defaultValue={100}
          format={v => `${v}%`}
          onChange={mix => onChange({ ...config, mix })}
        />
      </div>
    );
  }
}

export const robotEffect = new RobotEffectImpl();
